import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './Paging.scss'

const Paging = ({ currentPage, totalPages, className }) => {
    return (
        <div className={cx(styles.base, className)}>
            <span className={styles.current}>{currentPage}</span>
            <span className={styles.total}>{' / '}{totalPages}</span>
        </div>
    )
}

Paging.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    className: PropTypes.string,
}

export default Paging



// WEBPACK FOOTER //
// ./containers/MigrationScreen/components/Slider/components/Paging/Paging.jsx